// extracted by mini-css-extract-plugin
export default {"centered":"PrivateRoute_centered__tbliv"};